import { render, staticRenderFns } from "./EditAkquisition.vue?vue&type=template&id=24f86c2a&scoped=true"
import script from "./EditAkquisition.vue?vue&type=script&lang=ts"
export * from "./EditAkquisition.vue?vue&type=script&lang=ts"
import style0 from "./EditAkquisition.vue?vue&type=style&index=0&id=24f86c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f86c2a",
  null
  
)

export default component.exports